export default {
    invalidNameFieldMessage: "Veuillez saisir un nom valide",
    invalidEmailFieldMessage: "Veuillez saisir une adresse e-mail valide",
    updateProfilePictureTitle: "Téléchargez une nouvelle photo de profil",
    updateProfilePictureSupportedFileText: "JPG, PNG. Taille maximale 2 Mo",
    updateProfilePictureActionLabel: "Choisir un fichier",
    personalInfoFormTitle: "Informations personnelles",
    fullNameFieldLabel: "Nom complet",
    fullNameFieldPlaceholder: "Entrez votre nom",
    emailFieldLabel: "E-mail",
    emailFieldPlaceholder: "Entrez votre e-mail",
    preferredExamFieldLabel: "Examen préféré",
    targetScoreFieldLabel: "Score visé",
    termsAndConditionsFieldLabel: "J'accepte les Conditions d'utilisation et la Politique de confidentialité",
    termsAndConditionsNotAgreedMessage:"Veuillez accepter les conditions d'utilisation",
    invalidPasswordFieldMessage: "Veuillez saisir un mot de passe valide",
    invalidConfirmPasswordMessage: "Les mots de passe ne correspondent pas",
    passwordFieldPlaceholder: "Créez un mot de passe",
    passwordFieldLabel:"Mot de passe",
    oldPasswordFieldLabel: "Ancien mot de passe",
    oldPasswordFieldPlaceholder: "Entrez l'ancien mot de passe",
    currentPasswordFieldPlaceholder: "Entrez votre mot de passe",
    newPasswordFieldLabel: "Nouveau mot de passe",
    newPasswordFieldPlaceholder: "Entrez le nouveau mot de passe",
    confirmPasswordFieldLabel: "Confirmer le mot de passe",
    confirmPasswordFieldPlaceholder: "Confirmez votre mot de passe",
    confirmNewPasswordFieldPlaceholder: "Confirmez le nouveau mot de passe",
    updatePasswordFieldLabel: "Mettre à jour le mot de passe",
    preferredExamFieldDescription:"Pour quel examen vous préparez-vous ?",
    targetScoreFieldDescription:"Quel score souhaitez-vous obtenir ?",
    invalidPhoneFieldMessage: "Veuillez saisir un numéro de téléphone valide",
    selectProviderFieldPrompt: "Veuillez sélectionner un opérateur",
    providerFieldHelperText: "Sélectionnez un opérateur",
    passwordFieldHelperText: "Au moins 6 caractères",
    phoneNumberFieldLabel: "Numéro de Téléphone",
    providerFieldLabel: "Opérateur"
}
